import { homeApi } from "@/api/home";
import { defineQueryOptions } from "@pinia/colada";

export const HOME_KEYS = {
    root: ["home"] as const,
    data: () => [...HOME_KEYS.root, "data"] as const,
};

export const homeDataQuery = defineQueryOptions({
    key: HOME_KEYS.data(),
    query: () => homeApi.getHome(),
    staleTime: 30_000,
});
